import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore";
import CouponInput  from "components/Cart/CouponInput";
import { withRouter, Link } from "react-router-dom"

@withRouter
@observer
class CartTotal extends Component {
  
  componentDidMount() {
    shop.cart.update()
    shop.cart.handleDeliverProcess()
  }
  
  
  render() {
    
    //console.log("history",this.props.history)  
    const { showTax, fluid, className = "" } = this.props
    let {  brutto, tax, size, sumDiscount } = shop.cart
    let { sum } = shop.cart.data
    //console.log("ALL IN ONE",{sum, brutto, tax, size, sumDiscount})
    //console.log("noCouponPrice sum",shop.cart.data)
    let noCouponPrice = 0
    if(shop.cart.data.positions && shop.cart.activeCoupons.length > 0){
      shop.cart.data.positions.map( position => {
        //console.log("noCouponPrice position",position, position.extras && position.extras.customPrice, position.extras && position.extras.couponPrice , position.count , position.unit_multi)
        const couponPrice = position.extras && position.extras.brutto != null && position.extras.brutto !== "" ? position.extras.brutto : position.extras && position.extras.baseCustomerPrice;
        noCouponPrice += Number(parseFloat(couponPrice) * position.count * position.unit_multi);
      } )
    }
    shop.cart.setExtra("noCouponPrice",!isNaN(noCouponPrice)  ? noCouponPrice : 0)
    shop.cart.setExtra("couponCode",shop.cart.data && shop.cart.data.giftcards && shop.cart.data.giftcards[0] ? shop.cart.data.giftcards[0]  : "")
    console.log("noCouponPrice",noCouponPrice, sum, shop.cart.data, shop.cart.activeCoupons)
    return (
      <Table style={{ maxWidth: `${fluid ? "100%" : "320px"}` }} className={`CartTotal ${className}`}>
        <thead>
        {cmsStore.config.plugin.coupons &&
        <tr>
          <td colSpan={2}>
            <CouponInput/>
          </td>
        </tr>}
        
        
        <tr>
          <td><strong>{translate( "Positionen" )}</strong></td>
          <td className="tr">{size}</td>
        </tr>
        
        {noCouponPrice == 0 && <tr>
          <td><strong>{translate( "Zwischensumme" )}</strong></td>
          <td className="tr"><Price>{sum}</Price></td>
        </tr>}
        {noCouponPrice !== 0 &&  <tr>
          <td><strong>{translate( "Zwischensumme" )}</strong></td>
          <td className="tr">{this.props.location.pathname !== "/quickorder/" && <div className="strike black-60"><Price>{noCouponPrice}</Price></div>}
          <div className="fw7 red"><Price>{sum}</Price></div></td>
        </tr>}

        {noCouponPrice !== 0 && this.props.location.pathname !== "/quickorder/" && <tr>
          <td><strong>{translate( "Sie sparen" )}</strong></td>
          <td className="tr"><div className=""><Price>{noCouponPrice-sum}</Price></div></td>
        </tr>}


        
        {showTax &&
        <tr>
          <td><strong>{translate( "MwSt." )}</strong></td>
          <td className="tr"><Price>{tax}</Price></td>
        </tr>
        }
        
        {shop.config.useTaxNotice && <tr>
          <td colSpan={2}>
            <shop.config.useTaxNotice/>
          </td>
        </tr>}
        
        {showTax &&
        <tr>
          <td><strong>{translate( "Brutto" )}</strong></td>
          <td className="tr"><Price>{brutto}</Price></td>
        </tr>
        }
        
        
        {(shop.session.handId && !!sumDiscount) &&
        <React.Fragment>
          <tr className={"black-60 f5"}>
            <td>{translate( "Discount" )}</td>
            <td className="tr"><Price>{sumDiscount}</Price></td>
          </tr>
          
          <tr>
            <td><strong>{translate( "nach Rabatt" )}</strong></td>
            <td className="tr"><Price>{sum - sumDiscount}</Price></td>
          </tr>
        </React.Fragment>
        }
        
        </thead>
      </Table>
    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Cart/CartTotal.js